import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { UserRoleViewModel } from '../../business-entities/user-role-view-model';
import { UserRequestModel, UserViewModel } from '../../business-entities/user-view-model';
import { DashboardService } from '../../business-services/dashboard.service';
import { ReceptionService } from '../../business-services/reception.service';
import { RolesRightsService } from '../../business-services/roles-rights.service';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { AddReceptionComponent } from './add-reception/add-reception.component';
import { EditReceptionComponent } from './edit-reception/edit-reception.component';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import { AdminCommonService } from '../../services/admin-common.service';


@Component({
  selector: 'app-reception',
  templateUrl: './reception.component.html'
})
export class ReceptionComponent implements OnInit {

  paginationSub: Subscription;
  total$: Observable<number>;
  userRoleRightsDetails: UserRoleMenu;
  popupCloseResult = false;
  userList: UserViewModel[];
  userRequestModel: UserRequestModel = {
    roleId: 0,
    isAdvanceSearch: false,
    statusId: 0,
    dealerId: "",
    email:"",
    mobile:"",
    locationCode:""

  };
  userListPdf: UserViewModel[];
  userListExcel: UserViewModel[];
  isAdvanceSearch: boolean = false;
  roleList: UserRoleViewModel[] = [];
  dealerList: Array<SelectListItemViewModel>;
  receptionRole: boolean = false;
  filteredUserlist: UserViewModel[];//Created this variable for advance search
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;
  dealerId:string;
  defaultDealerId:string;
  dealerSelected: string = '';
  defaultDealerSelected: string = '';
  currentUserPriority:number;
  areCodesHidden = false;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(private router: Router,
    private adminCommonService :AdminCommonService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private receptionBusinessService: ReceptionService,
    private dealerService: DealerBusinessService,
    private userService: UserDataService,
    private translate: TranslateService,
    private modalService: NgbModal, config: NgbModalConfig,
    private excelService: ExcelService,
    private rolesRightsService: RolesRightsService,
    private dashboardService: DashboardService,
    private _eref: ElementRef) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['userName', 'dealerName', 'email', 'mobile', 'roleName'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.pService.dataSource = [];
    this.areCodesHidden = localStorage.getItem('Theme') === 'mg';
    if (this.dashboardService.isFromDashboard) {
      this.selectedStatus = fromEnums.StatusCode.Active;
    }

    if (this.selectedStatus != undefined) {
      this.userRequestModel.statusId = this.selectedStatus;
    }
    this.StatusList = this.dashboardService.getStatusList();
    this.userRoleRightsDetails = (this.userService.currentUserValue
      .userRoleMenuDetails as any[]).find(
        menu => menu.moduleId === fromEnums.ModuleNames.Reception
      );
      this.getRoleList();
      this.GetDealerList();
  }

  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && event.target.className.indexOf('ng-option')== -1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {       
        this.userRequestModel.isAdvanceSearch = false;             
      }
    }
  }
  StatusChange(status: any,isFromAdvanceSearch: boolean) {
    if (status == undefined) {
      this.userRequestModel.statusId = fromEnums.StatusCode.All;
    } else {
      this.userRequestModel.statusId = status;
    }
    if(isFromAdvanceSearch === false){
      this.getUserList(this.userRequestModel);
    }
  }

  async getUserList(userRequestModel: UserRequestModel) {
    this.spinner.show();
    await this.receptionBusinessService.getUserList(userRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.userList = response.responseObject;
        this.filteredUserlist = response.responseObject;
        this.pService.dataSource = response.responseObject;
        if(this.roleList?.length == 0){
          this.getRoleList();
        }
        this.paginationSub = this.pService.dealers$.subscribe((result: any) => {
          this.userList = this.UserDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }
    });
  }

  onAdd() {

    const modalref = this.modalService.open(AddReceptionComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    }, _error => { 
      // This is intentional
     });
  }

  editUser(user: any) {
    this.receptionBusinessService.userId = user.userId;
    this.receptionBusinessService.userDetails = user;
    const modalref = this.modalService.open(EditReceptionComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    }, _error => { 
       // This is intentional
    });
  }

  deleteUser(id: string) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblUser"),false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
       // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.adminCommonService.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.receptionBusinessService.deleteUser(id).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode) {
            this.getUserList(this.userRequestModel);
          }
        });
      }
    });
  }

  private UserDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {

      for (let index = 0; index < List.length; index++) {
        const element = List[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.no = index + 1;
        single.adUserId = element.adUserId;
        single.dealerId = element.dealerId;
        single.dealerName = element.dealerId === '-1' ? 'All' : element.dealerName;
        single.mobile = element.mobile;
        single.mobileCode = element.mobileCode;
        single.email = element.email;
        single.isActive = element.isActive;
        single.roleId = element.roleId;
        single.roleName = element.roleName;
        single.userId = element.userId;
        single.userName = element.userName;
        single.landline = element.landline;
        single.functionCode = element.functionCode;
        single.functionCodeDescription = element.functionCodeDescription;
        single.locationCode = element.locationCode;
        single.locationName = element.locationName;
        single.isEditable = this.roleList?.filter(x=>x.id===element.roleId)[0]?.priority > this.currentUserPriority ? true: false
        single.defaultDealerId = element.defaultDealerId;
        single.defaultDealerName = this.dealerList.filter(x=>x.value===element.defaultDealerId)[0]?.text;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  private UserExcelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {

      for (let index = 0; index < List.length; index++) {
        const element = List[index];

        let single = Object();
        single.No = index + 1;
        single.UserName = element.userName;
        single.Role = element.roleName;
        single.Dealers = element.dealerId === '-1' ? 'All' : element.dealerName;
        single.Mobile = (element.mobileCode ? '+' + element.mobileCode : '') + (element.mobile ? '-' + element.mobile : '');
        single.Email = element.email;
        single.ActiveStatus = element.isActive ? 'Active' : 'InActive';
        supperArray.push(single);
      }
    }
    return supperArray;
  }


 


  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    this.dashboardService.isFromDashboard = false;
  }

  public get documentTypes(): typeof fromEnums.DocumentsType {
    return fromEnums.DocumentsType;
  }

  public async exportAsXLSX(_excel: number) {
    this.spinner.show();
    this.userListExcel = this.UserExcelDataMapper(this.filteredUserlist);

    this.spinner.hide();
    this.excelService.exportAsExcelFile(this.userListExcel, 'users_af');
  }

  public async onDownloadPDF(_pdf: number) {
    this.spinner.show();
    this.userListPdf = this.UserDataMapper(this.filteredUserlist);

    setTimeout(() => {
      const doc = new jsPDF();
      autoTable(doc, { html: '#userPdf', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 } });
      doc.save('User-List.pdf');
      this.spinner.hide();
    }, 100)
  }

  onSearch() {
    this.userRequestModel.isAdvanceSearch = true;
  }

  AdvanceSearchSubmit() {
    this.userRequestModel.isAdvanceSearch = true;
    this.userRequestModel.roleId = this.userRequestModel.roleId ? this.userRequestModel.roleId : 0;
    this.getUserList(this.userRequestModel);
    this.userRequestModel.isAdvanceSearch = false;

  }

  onReset() {
    this.userRequestModel.isAdvanceSearch = false;
    this.userRequestModel.roleId = 0;
    this.selectedStatus = undefined;
    this.userRequestModel.statusId = fromEnums.StatusCode.All;
    this.userRequestModel.dealerId = '';
    this.dealerId = null;
    this.userRequestModel.defaultDealerId = '';
    this.defaultDealerId = null;
    this.userRequestModel.email = '';
    this.userRequestModel.mobile = '';
    this.userRequestModel.locationCode = '';
    this.getUserList(this.userRequestModel);
  }

  onClose() {
    this.onReset();
    this.userRequestModel.isAdvanceSearch = false;
  }
  getRoleList() { 
      this.spinner.show();
      this.rolesRightsService.getRoleList().then(response => {
        if (response) {
          this.roleList = response.responseObject.result;
          this.currentUserPriority=this.roleList.filter(x=>x.id===this.userService.currentUserValue.roleType)[0]?.priority;
          //if super admin login
          if(this.userService.currentUserValue.roleType ===  fromEnums.UserRoles.SuperAdmin){
            this.currentUserPriority=1;
          }
          this.getUserList(this.userRequestModel);
        }
      }).finally(()=>{
        this.spinner.hide();
      });
  }

  onRoleChange(role) {
    let r = role.split(':');
    let ro = +r[1];
    if (ro === fromEnums.UserRoles.Reception) {
      this.receptionRole = true;
    }
    else {
      this.receptionRole = false;
    }
  }
  async GetDealerList() {
    await this.dealerService.getDealerBrandList().then(res => {
      if (res) {
        if (res.dealerList) {
          this.dealerList = this.mapdealer(res.dealerList);
        }
      }
      if(this.dealerList.length === 1){
        this.dealerId = this.dealerList[0].value;
      }
    })
  }
  mapdealer(array: DealerViewModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onDealerSelected(dealerId: string) {
    this.dealerId = dealerId ?? null;
    this.dealerSelected = this.dealerList.find(x => x.value === dealerId)?.text;
    this.userRequestModel.dealerId = this.dealerId;
    this.userRequestModel.isAdvanceSearch = true;
    this.userRequestModel.roleId = this.userRequestModel.roleId ? this.userRequestModel.roleId : 0;
    this.getUserList(this.userRequestModel);
    this.userRequestModel.isAdvanceSearch = false;
  }

  onDefaultDealerSelected(dealerId: string) {
    this.defaultDealerId = dealerId ?? null;
    this.defaultDealerSelected = this.dealerList.find(x => x.value === dealerId)?.text;
    this.userRequestModel.defaultDealerId = this.defaultDealerId;
    this.userRequestModel.isAdvanceSearch = true;
    this.userRequestModel.roleId = this.userRequestModel.roleId ? this.userRequestModel.roleId : 0;
    this.getUserList(this.userRequestModel);
    this.userRequestModel.isAdvanceSearch = false;
  }
}
